import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const MoveInvoiceSchema = z.object({
    buyerId: z.string().regex(/^[0-9a-f]{24}$/i),
    tenantId: z.string().min(1),
});

export class MoveInvoiceDto extends FromSchema(MoveInvoiceSchema) {
    buyerId: string;
    tenantId: string;
}
